import './styles.scss';
import { ReactComponent as CompletedIcon } from '../../../assets/icons/status/completed.svg';
import { ReactComponent as PendingIcon } from '../../../assets/icons/status/pending.svg';
import { ReactComponent as RejectedIcon } from '../../../assets/icons/status/rejected.svg';
import { ReactComponent as ReviewIcon } from '../../../assets/icons/status/review.svg';
import { ReactComponent as CancelledIcon } from '../../../assets/icons/status/cancelled.svg';
import Tooltip from '@mui/material/Tooltip';

import l from '../../../lang';

interface StatusIconProps {
  status: string;
}

const StatusIcon = ({ status }: StatusIconProps) => (
  <Tooltip title={l(`refunds.status.${status}`)}>
    <div>
      {(status ?? '').toLowerCase() === 'completed' && <CompletedIcon />}
      {['pending', 'created'].includes((status ?? '').toLowerCase()) && <PendingIcon />}
      {['rejected', 'declined', 'failed'].includes((status ?? '').toLowerCase()) && <RejectedIcon />}
      {['review'].includes((status ?? '').toLowerCase()) && <ReviewIcon />}
      {['cancelled'].includes((status ?? '').toLowerCase()) && <CancelledIcon />}
    </div>
  </Tooltip>
);

export default StatusIcon;
